"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomPolarAnswerWithNavigateButtonsWidget = void 0;
var React = require("react");
require("react-datepicker/src/stylesheets/datepicker.scss");
var journey_model_1 = require("@athena-portal/journey-model");
var FalconQuestionWidgetBase_1 = require("./FalconQuestionWidgetBase");
var journey_services_1 = require("@athena-portal/journey-services");
var CustomPolarAnswerWithNavigateButtonsWidget = exports.CustomPolarAnswerWithNavigateButtonsWidget = /** @class */ (function (_super) {
    __extends(CustomPolarAnswerWithNavigateButtonsWidget, _super);
    function CustomPolarAnswerWithNavigateButtonsWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnChangeEvent = function (event) {
            if (event.target.value === "true") {
                _this.setState({ nextPageIdCaseYes: _this.getSetting("nextPageIdIfYes"), validationMessage: "", nextPageIdCaseNo: undefined });
            }
            else {
                _this.setState({ nextPageIdCaseNo: _this.getSetting("nextPageIdIfNo"), validationMessage: "", nextPageIdCaseYes: undefined });
            }
            _this.changelogRecorder.recordQuestion("change", _this.props);
        };
        _this.navigateNext = function () {
            if (_this.state.nextPageIdCaseYes) {
                _this.props.engine.navigate(_this.state.nextPageIdCaseYes);
            }
            else if (_this.state.nextPageIdCaseNo) {
                _this.props.engine.navigate(_this.state.nextPageIdCaseNo);
            }
            else {
                _this.setState({ validationMessage: "Please answer this to carry on" });
            }
        };
        _this.navigateBack = function () {
            if (_this.getSetting("previousPageId")) {
                _this.props.engine.navigate(_this.getSetting("previousPageId"));
            }
            else if (_this.getSetting("previousPageIdCondition")) {
                if (journey_services_1.ConditionEvaluator.evaluateCondition(_this.props.journey.displayConditions, _this.getSetting("previousPageIdCondition"), _this.props.interaction)) {
                    _this.props.engine.navigate(_this.getSetting("previousPageIdIfConditionTrue"));
                }
                else {
                    _this.props.engine.navigate(_this.getSetting("previousPageIdIfConditionFalse"));
                }
            }
        };
        _this.state = {
            nextPageIdCaseYes: undefined,
            nextPageIdCaseNo: undefined,
            validationMessage: "",
            previousPageIdCondition: undefined,
            previousPageIdConditionCaseTrue: undefined,
            previousPageIdConditionCaseFalse: undefined
        };
        return _this;
    }
    CustomPolarAnswerWithNavigateButtonsWidget.prototype.renderInputField = function () {
        var label = this.getSetting("label") ? this.getSetting("label") : this.renderHtml(this.getSetting("labelHtml"));
        return (React.createElement("div", { className: "w-100" },
            React.createElement("div", { className: "panel form-group p-4" },
                React.createElement("label", null, label),
                React.createElement("div", { className: "input-group" },
                    React.createElement("div", { className: "custom-control custom-radio" },
                        React.createElement("input", { id: "".concat(this.props.question.name, "-true"), className: "custom-control-input null", type: "radio", name: "".concat(this.props.question.name, "-true"), value: "true", checked: !!this.state.nextPageIdCaseYes, onChange: this.handleOnChangeEvent }),
                        React.createElement("label", { className: "custom-control-label", htmlFor: "".concat(this.props.question.name, "-true") }, "Yes")),
                    React.createElement("div", { className: "custom-control custom-radio" },
                        React.createElement("input", { id: "".concat(this.props.question.name, "-false"), className: "custom-control-input null", type: "radio", name: "".concat(this.props.question.name, "-false"), value: "false", checked: !!this.state.nextPageIdCaseNo, onChange: this.handleOnChangeEvent }),
                        React.createElement("label", { className: "custom-control-label", htmlFor: "".concat(this.props.question.name, "-false") }, "No"))),
                React.createElement("div", { className: "invalid-feedback d-block" }, this.state.validationMessage)),
            React.createElement("button", { className: "mb-0 btn btn-primary btn-next btn-next-arrow-separate", id: "".concat(this.props.question.name), onClick: this.navigateNext }, "Next"),
            (this.getSetting("previousPageId") || this.getSetting("previousPageIdCondition")) && React.createElement("button", { className: "btn btn-back", onClick: this.navigateBack }, "Back")));
    };
    CustomPolarAnswerWithNavigateButtonsWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "previousPageId", type: journey_model_1.TypeDescriptions.String },
            { name: "nextPageIdIfYes", type: journey_model_1.TypeDescriptions.String },
            { name: "nextPageIdIfNo", type: journey_model_1.TypeDescriptions.String },
            { name: "labelHtml", type: journey_model_1.TypeDescriptions.String },
            { name: "previousPageIdCondition", type: journey_model_1.TypeDescriptions.String },
            { name: "previousPageIdIfConditionTrue", type: journey_model_1.TypeDescriptions.String },
            { name: "previousPageIdIfConditionFalse", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], CustomPolarAnswerWithNavigateButtonsWidget);
    return CustomPolarAnswerWithNavigateButtonsWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
//# sourceMappingURL=CustomPolarAnswerWithNavigateButtonsWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/CustomPolarAnswerWithNavigateButtonsWidget.js
// module id = 3630
// module chunks = 0